import { StyledDropArea } from "@components/fileUploader/FileUploader.styles";
import { IconWrapper, StyledInput } from "@components/inputs/input/Input.styles";
import { StyledToken } from "@components/token/Token.styles";
import { StyledTokenizerOuterWrapper } from "@components/token/Tokenizer.styles";
import styled from "styled-components";

import { T_PLAIN_big } from "../../../global.style";

export const StyledFileInput = styled(StyledInput)<{ $hasValue: boolean; }>`
    border: none;
    cursor: default;
    pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};

    ${StyledDropArea} {
        border-radius: inherit;
        border-width: 2px;
        border-color: ${props => props.theme.C_FIELD_line};
        border-style: ${props => props.$hasValue ? "solid" : "dashed"};
        width: 100%;
        height: 100%;
    }

    ${IconWrapper} {
        display: flex;
        align-items: center;
    }
    ${StyledTokenizerOuterWrapper} {
        height: 100%;
        display: flex;
        align-items: center;
        width: calc(100% - 34px);
        left: ${props => props.$isReadOnly ? "0" : "12px"};
        top: 1px;
    }
`;

export const FileNamesWrapper = styled.div<{
    $hasError: boolean;
    $isReadOnly: boolean;
}>`
    ${T_PLAIN_big};
    width: calc(100% - 34px);
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: ${props => props.$isReadOnly ? null : "12px"};
    padding-top: ${props => props.$hasError ? "9px" : null};
`;

export const ErrorWrapper = styled.div`
    padding: 0 12px;
    position: absolute;
    width: 100%;
    top: 0;
`;


export const FileInputStyledMenu = styled.div`
    outline: none;
    border-radius: 3px;
    box-shadow: 0 0 12.7px 0.3px rgba(0, 0, 0, 0.15);
    background: ${props => props.theme.C_BG_popover};
    ${StyledToken} {
        color: ${props => props.theme.C_TEXT_link};
    }
    list-style: none;
    padding: 6px 12px;
    display: grid;
    gap: 8px;
    position: absolute;
    margin: 0;
    border-top: 0;
    cursor: default;
    z-index: 1000;
`;